import type { FC } from 'react';
import React from 'react';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Img } from '@alfa-bank/site-img';
import { ArrowPopover as Tooltip } from '@alfa-bank/site-popover/arrow-popover';
import cn from 'classnames';

import { TransparentButton } from '../transparent-button';
import { DEFAULT_DESKTOP_TEXTS } from '../../config';
import { noop } from '../../helpers';

import styles from './city-header.css';
import type { ICityHeaderProps, ICityNameProps } from './models';

const CityName: FC<ICityNameProps> = ({ cityIcon, cityName, onClick }) => {
    const button = (
        // eslint-disable-next-line external-classname/specificity
        <TransparentButton className={styles.cityName} onClick={onClick} tabIndex={0}>
            {cityName}
            {/** проверяем только на false, потому что undefined или true одно и тоже */}
            {cityIcon && cityIcon.iconVisible !== false && (
                <Img
                    alt={cityIcon.alt}
                    height={14}
                    src={cityIcon.iconUrl}
                    styler={{ marginLeft: 8 }}
                    width={12}
                />
            )}
        </TransparentButton>
    );

    return cityIcon ? (
        <Tooltip
            className={cn(styles.external, styles.tooltipContainer)}
            content={
                <Text fontPreset="primaryNormal" tag="span">
                    {cityIcon.title}
                </Text>
            }
            contentContainerProps={{ showCloseButton: false }}
            isHover
            offset={[0, 20]}
            placement="right"
        >
            {button}
        </Tooltip>
    ) : (
        button
    );
};

export const CityHeader: FC<ICityHeaderProps> = ({
    city,
    cityIcon,
    className,
    onClick = noop,
    searchMode,
    styler,
}) => (
    <Text className={cn(styles.external, styles.here, className)} styler={styler} tag="h2">
        {searchMode ? DEFAULT_DESKTOP_TEXTS.titleWhileSearch : DEFAULT_DESKTOP_TEXTS.titleForHeader}
        <CityName cityIcon={cityIcon} cityName={city.cityNameRus} onClick={() => onClick(city)} />
    </Text>
);
